export default "__VITE_ASSET__EeQ8Qc5s__"